import {Enumify} from "enumify-ts";

class LoadUnitOfMeasure extends Enumify<LoadUnitOfMeasure>() {

    static VOLUME_M3 = new LoadUnitOfMeasure("Cubic Metres");
    static WEIGHT_TON = new LoadUnitOfMeasure("Tonne");
    static QUANTITY_EACH = new LoadUnitOfMeasure("Qty");
    static _ = LoadUnitOfMeasure._closeEnum();

    constructor(
        public description: string
    ) {
        super();
    }

}

export default LoadUnitOfMeasure;
